import { Tabs, TabsList, TabsTrigger } from '@/components/shadcn/tabs';
import { IMapProvider } from '@/types/map';

export interface Props {
  currentMap: IMapProvider;
  handleMapChange: (value: IMapProvider) => void;
}

export default function SwitchMap({ handleMapChange, currentMap }: Props) {
  return (
    <div className="absolute left-1/2 top-3 z-40 mx-auto flex -translate-x-1/2 items-center">
      <Tabs value={currentMap} aria-label="Platform">
        <TabsList className="grid grid-cols-2">
          <TabsTrigger
            value={IMapProvider.Mapbox}
            className="no-focus-ring"
            onClick={() => handleMapChange(IMapProvider.Mapbox)}>
            Satellite 1
          </TabsTrigger>
          <TabsTrigger
            value={IMapProvider.Apple}
            className="no-focus-ring"
            onClick={() => handleMapChange(IMapProvider.Apple)}>
            Satellite 2
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
}
